"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const LogoutModal_1 = __importDefault(require("./LogoutModal"));
const react_redux_1 = require("react-redux");
const LogoutModalWrapper = () => {
    const { isLogoutModalOpen } = (0, react_redux_1.useSelector)((state) => state.dialogModal);
    return isLogoutModalOpen ? react_1.default.createElement(LogoutModal_1.default, null) : null;
};
exports.default = LogoutModalWrapper;
